var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGeneralReset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32.099,
    height: 32.099,
    viewBox: "0 0 32.099 32.099",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: 0.03,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6713ac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#923cd5"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_35498",
    "data-name": "Group 35498",
    transform: "translate(-42.25 -232.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35523",
    "data-name": "Path 35523",
    d: "M210.358,343.234a15.3,15.3,0,1,0,15.3,15.3A15.317,15.317,0,0,0,210.358,343.234Zm0,0",
    transform: "translate(-152.059 -110.234)",
    stroke: "rgba(207,137,255,0.44)",
    strokeWidth: 1.5,
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "rotation-lock",
    transform: "translate(49.947 224.148)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35485",
    "data-name": "Group 35485",
    transform: "translate(4.965 19.33)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35484",
    "data-name": "Group 35484"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35517",
    "data-name": "Path 35517",
    d: "M150.069,115.33h-.552v-1.1a2.207,2.207,0,0,0-4.414,0v1.1h-.552a.552.552,0,0,0-.552.552V120.3a.552.552,0,0,0,.552.552h5.517a.552.552,0,0,0,.552-.552v-4.414A.552.552,0,0,0,150.069,115.33Zm-3.862-1.1a1.1,1.1,0,0,1,2.207,0v1.1h-2.207Zm3.31,5.517H145.1v-3.31h4.414Z",
    transform: "translate(-144 -112.02)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_35487",
    "data-name": "Group 35487",
    transform: "translate(0 16.02)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35486",
    "data-name": "Group 35486",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35518",
    "data-name": "Path 35518",
    d: "M17.309,21.025a.549.549,0,0,0-.716.308l-.33.825a8.267,8.267,0,1,0-2.135,7.989.552.552,0,0,0-.78-.78,7.174,7.174,0,1,1,1.942-6.561L14.183,21.7a.552.552,0,0,0-.78.78l2.207,2.207c.012.012.029.017.042.028a.53.53,0,0,0,.136.09.517.517,0,0,0,.212.044.553.553,0,0,0,.111-.011c.015,0,.026-.015.041-.02a.554.554,0,0,0,.154-.074.582.582,0,0,0,.061-.041.556.556,0,0,0,.143-.2s0,0,0,0l1.1-2.759A.551.551,0,0,0,17.309,21.025Z",
    transform: "translate(0 -16.02)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.3
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_35488",
    "data-name": "Group 35488",
    transform: "translate(0 16.02)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35518-2",
    "data-name": "Path 35518",
    d: "M17.309,21.025a.549.549,0,0,0-.716.308l-.33.825a8.267,8.267,0,1,0-2.135,7.989.552.552,0,0,0-.78-.78,7.174,7.174,0,1,1,1.942-6.561L14.183,21.7a.552.552,0,0,0-.78.78l2.207,2.207c.012.012.029.017.042.028a.53.53,0,0,0,.136.09.517.517,0,0,0,.212.044.553.553,0,0,0,.111-.011c.015,0,.026-.015.041-.02a.554.554,0,0,0,.154-.074.582.582,0,0,0,.061-.041.556.556,0,0,0,.143-.2s0,0,0,0l1.1-2.759A.551.551,0,0,0,17.309,21.025Z",
    transform: "translate(0 -16.02)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.2
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneralReset);
export default __webpack_public_path__ + "static/media/general-reset.65832bd3550dd23d59df9ee3d869e6a3.svg";
export { ForwardRef as ReactComponent };